import { Component, OnDestroy, OnInit } from '@angular/core';
import { from, Observable, of, Subscription, switchMap } from 'rxjs';
import { EventService } from '@app/services/util-services/root-services/event-service';
import { AsyncPipe, NgClass, NgOptimizedImage } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import * as initUser from '@app/store/init-user';
import { select, Store } from '@ngrx/store';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';
import * as fromRoot from '@app/store';
import { UserModel } from '@app/models/server/user.model';
import { LetDirective, PushPipe } from '@ngrx/component';
import { environment } from '@src/environments/environment';
import {TapEffect} from '@app/components/directives/tap-effect.ts/tap-effect';

@Component({
  selector: 'app-b2b-nav-menu',
  templateUrl: './b2b-nav-menu.component.html',
  styleUrls: ['./b2b-nav-menu.component.scss'],
  standalone: true,
  imports: [
    AsyncPipe,
    NgClass,
    RouterLink,
    LetDirective,
    PushPipe,
    NgOptimizedImage,
    TapEffect,
  ],
})
export class B2bNavMenuComponent implements OnInit, OnDestroy {
  userInfo$: Observable<UserModel>;
  showMenu: boolean;

  showMenuSubscription: Subscription;

  public appPages = [];

  headerMenuItem: {
    image: string;
    title: string;
    description: string;
  } = {
    image: '',
    title: '',
    description: '',
  };

  menuData$: Observable<{ appPages: any; headerMenuItem: any }>;

  constructor(
    private eventService: EventService,
    private router: Router,
    private b2bDeviceUtilService: B2bDeviceUtilService,
    private store: Store<fromRoot.State>,
  ) {}

  ngOnInit(): void {
    this.showMenuSubscription = this.eventService.showMenu$?.pipe().subscribe({
      next: (result) => {
        this.showMenu = result;
        if (result) {
          if (!this.menuData$) {
            this.menuData$ = this.loadMenuItems();
          }
          if (!this.userInfo$) {
            this.init();
          }
        }
      },
    });
  }

  init() {
    if (!this.b2bDeviceUtilService?.isServer()) {
      this.userInfo$ = this.store.pipe(select(initUser.getUser));
    }
  }

  onClick() {
    this.eventService.toggleMenu();
  }

  loadMenuItems() {
    if (this.appPages?.length > 0) {
      // do nothing
      return of({
        appPages: this.appPages,
        headerMenuItem: this.headerMenuItem,
      });
    } else {
      return from(
        import('@app/services/util-services/lazy-services/menu-service'),
      ).pipe(
        switchMap((r) => {
          const ms = new r.MenuService();
          this.appPages = ms.getAllThemes();
          this.headerMenuItem = ms.getDataForTheme(null);
          return of({
            appPages: this.appPages,
            headerMenuItem: this.headerMenuItem,
          });
        }),
      );
    }
  }

  close() {
    this.eventService.toggleMenu();
  }

  openPage(page): void {
    this.router.navigateByUrl(page.url).then();
    this.close();
  }

  login() {
    this.router.navigateByUrl('/auth/login').then();
    this.close();
  }

  register() {
    this.router.navigateByUrl('/auth/register').then();
    this.close();
  }

  logout(): void {
    this.eventService.loggedOutEvent.emit();
    this.close();
  }

  ngOnDestroy(): void {
    if (this.showMenuSubscription) {
      this.showMenuSubscription?.unsubscribe();
    }
  }

  protected readonly environment = environment;
}
